import React, { memo, useEffect, useMemo, useState } from "react";
import { bigIconList } from "../../digitalArena/modules/Plaudit/PlauditIcons";
import EmojiEmotionsIcon from "@material-ui/icons/EmojiEmotions";
import CloseIcon from '@material-ui/icons/Close';
import { Col, Label, Row } from "reactstrap";
import SystemLabel from "../../system/SystemLabel/SystemLabel";
import { Accordion, AccordionDetails, AccordionSummary, Dialog, DialogContent, IconButton, withStyles, Typography } from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PublishIcon from '@material-ui/icons/Publish';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { authHeader } from "../../helpers/authHeader";
import { handleResponse } from "../../helpers/handleresponse";
const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: "white",
    },
});
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

export const PlauditIconSelector = memo(({ eventId, value = "", onChange, label }) => {
    const [open, setOpen] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [deleteMode, setDeleteMode] = useState(false);
    const toggleIcon = (icon) => {
        if (value.includes(icon)) {
            onChange(value.replace(icon + ";", ""));
        }
        else {
            onChange(value + icon + ";")
        }
    }
    const iconCategories = useMemo(() => {
        const categories = [];
        for (const cat in bigIconList) {
            if (Object.hasOwnProperty.call(bigIconList, cat)) {
                categories.push(cat);
            }
        }
        return categories;
    }, [bigIconList])
    const selectedIcons = useMemo(() => {
        return value.split(";").filter(x => x !== "");
    }, [value])
    const uploadedIcons = useMemo(() => {
        const filenames = [];
        for (const key in uploadedFiles) {
            if (Object.hasOwnProperty.call(uploadedFiles, key)) {
                filenames.push(key);
            }
        }
        return filenames;
    }, [uploadedFiles])
    useEffect(() => {
        getUploadedIcons();
    }, [])

    const getUploadedIcons = () => {
        const requestOptions = {
            method: "GET",
            headers: authHeader({}),
        };
        fetch(
            `./api/files/icons/${eventId}`,
            requestOptions
        ).then((response) =>
            response.text().then((text) => {
                try {
                    const storageSummary = JSON.parse(text);
                    var files = {};
                    for (const file of storageSummary.files) {
                        files[file.name] = file.url;
                    }
                    setUploadedFiles(files);
                } catch (error) {
                    console.error("DOWNLOAD_ERROR", error);
                }
            })
        );
    };
    const onUploadedFile = (file) => {
        setUploadedFiles({ ...uploadedFiles, ...file })
    }
    const deleteIcon = (icon) => {
        if (uploadedFiles[icon]) {
            if (window.confirm(`Är du säker att du vill radera ${icon}? Detta kan ej ångras.`)) {
                fetch(
                    `./api/files/icon/${eventId}/${icon}`,
                    {
                        method: "DELETE",
                        headers: authHeader({}),
                    }
                ).then((response) => {
                    const newFiles = { ...uploadedFiles };
                    delete newFiles[icon];
                    if (value.includes(icon)) {
                        onChange(value.replace(icon + ";", ""));
                    }
                    setUploadedFiles(newFiles);
                });
            }
        }
    }
    return (
        <div>
            <Row>
                <Col className="text-left">
                    <Label className="primary-text">
                        <SystemLabel name={label} />
                    </Label>
                </Col>
                <Col className="text-right">
                    <IconButton className="dark-button" style={{ marginTop: '-10px' }} onClick={() => setOpen(!open)}>
                        <EmojiEmotionsIcon />
                    </IconButton>
                </Col>
            </Row>
            {open ?
                <Dialog
                    open={open}
                    onClose={() => setOpen(false)}
                    maxWidth={"md"}
                    fullWidth={true}
                >
                    <DialogTitle style={{ backgroundColor: "#373842", color: "white" }} onClose={() => setOpen(false)}>
                        <SystemLabel name={"IconSelectTitle"} />
                    </DialogTitle>
                    <DialogContent style={{ backgroundColor: "#2c2d36", color: "white" }}>

                        <Accordion style={{ backgroundColor: "#373842", color: "white" }} expanded={selectedIcons.length > 0}>
                            <AccordionSummary><SystemLabel name={"SelectedIcons"} /></AccordionSummary>
                            <AccordionDetails style={{ backgroundColor: "#2c2d36", color: "white" }}>
                                <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "center" }}>
                                    {selectedIcons.map((icon) => {
                                        return <button key={icon} style={{
                                            height: "100px",
                                            width: "100px",
                                            borderRadius: "5px",
                                            border: 0,
                                            backgroundColor: "#0000"
                                        }}
                                            onClick={() => toggleIcon(icon)}
                                        >
                                            <img crossOrigin="anonymous" style={{ width: "100%", height: "100%" }} src={uploadedFiles[icon] ? uploadedFiles[icon] : `https://cdn.jsdelivr.net/npm/twemoji@latest/2/svg/${icon.toLowerCase()}.svg`} />
                                        </button>
                                    })}
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion style={{ backgroundColor: "#373842", color: "white" }}>
                            <AccordionSummary>
                                <div style={{ width: "50%", textAlign: "left", display: "flex", alignItems: "center" }}>
                                    <SystemLabel name={"UploadedIcons"} />
                                </div>
                                <div style={{ width: "50%", textAlign: "right" }}>
                                    <IconUploadButton eventId={eventId} onUploaded={onUploadedFile} />
                                    <button style={{
                                        marginRight: 10,
                                        borderRadius: 8,
                                        cursor: "pointer",
                                        color: "#fff",
                                        borderWidth: "1px",
                                        borderStyle: "solid",
                                        borderColor: deleteMode ? "#fff" : "#535562",
                                        background: deleteMode ? "#5c5e5b" : "#4c4e5b",
                                        padding: "6px 12px",
                                        marginTop: "10px",
                                    }} onClick={(event) => { event.stopPropagation(); setDeleteMode(!deleteMode); }} >
                                        <DeleteForeverIcon style={{ color: "#fff" }} />
                                        <SystemLabel name={"DeleteIcons"} />
                                    </button>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails style={{ backgroundColor: "#2c2d36", color: "white" }}>
                                <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "center" }}>
                                    {uploadedIcons.map((icon) => {
                                        return <button key={icon} style={{
                                            height: "100px",
                                            width: "100px",
                                            borderRadius: "5px",
                                            borderWidth: "2px",
                                            borderStyle: "solid",
                                            borderColor: selectedIcons.includes(icon) ? "white" : "#0000",
                                            backgroundColor: "#0000",
                                            position: "relative"
                                        }}
                                            onClick={() => deleteMode ? deleteIcon(icon) : toggleIcon(icon)}
                                        >
                                            {deleteMode ?
                                                <div style={{ position: "absolute", inset: 0, backgroundColor: "rgba(100,100,100,0.5", display: "flex", alignItems: "center", justifyContent: "center" }}> <DeleteForeverIcon style={{ color: "#fff" }} /> </div> : null}
                                            <img crossOrigin="anonymous" style={{ width: "100%", height: "100%" }} src={uploadedFiles[icon]} />
                                        </button>
                                    })}
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        {iconCategories.map((category, i) => {
                            return <Accordion key={i} style={{ backgroundColor: "#373842", color: "white" }}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}> <SystemLabel name={"Plaudit_"+category} /></AccordionSummary>
                                <AccordionDetails style={{ backgroundColor: "#2c2d36", color: "white" }}>
                                    <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "center" }}>
                                        {bigIconList[category].map((icon) => {
                                            return <button key={icon.code} style={{
                                                height: "100px",
                                                width: "100px",
                                                borderRadius: "5px",
                                                borderWidth: "2px",
                                                borderStyle: "solid",
                                                borderColor: selectedIcons.includes(icon.code) ? "white" : "#0000",
                                                backgroundColor: "#0000"
                                            }}
                                                onClick={() => toggleIcon(icon.code)}
                                            >
                                                <img crossOrigin="anonymous" style={{ width: "100%", height: "100%" }} src={`https://cdn.jsdelivr.net/npm/twemoji@latest/2/svg/${icon.code.toLowerCase()}.svg`} />
                                            </button>
                                        })}
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        })}
                      
                    </DialogContent>
                </Dialog>
                : null}
        </div>
    );
});


const IconUploadButton = ({ eventId, onUploaded }) => {
    const onUpload = (e) => {
        const file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            if (reader.result) {
                const fileInfo = {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    file: reader.result,
                };
                const requestOptions = {
                    method: "POST",
                    headers: authHeader({ "Content-Type": "application/json" }),
                    body: JSON.stringify(fileInfo),
                };
                fetch(
                    `./api/files/icons/${eventId}`,
                    requestOptions
                )
                    .then(handleResponse)
                    .then((file) => {
                        let newFile = {}
                        newFile[file.name] = file.url
                        onUploaded(newFile);
                    })
                    .catch((err) => {
                        console.error(err.message);
                    });
            }
        };
    };


    return <>
        <label htmlFor="icon-upload-button" style={{
            marginRight: 10,
            borderRadius: 8,
            cursor: "pointer",
            border: "1px solid #535562",
            background: "#4c4e5b",
            padding: "6px 12px !important",
            marginTop: "10px !important",
        }} className="editor-full-btn primary-text">
            <PublishIcon />
            <SystemLabel name={"UploadIcon"} />
        </label>
        <input id="icon-upload-button" className="file-upload" type="file" accept={"image/*"} onChange={(e) => onUpload(e)} />
    </>
}